// extracted by css-extract-rspack-plugin
export default {"noHover":"_2bc2943","authButton":"_57a8ed1a","borderLeft":"_b01fcb93","dropdownBodyWrapper":"_9bff8d9c","dropdown":"_b6a95fdf","dropdownLink":"_1dd3bfbf"};